import { styled, makeStyles } from '@mui/styles';

export const useActiveStyle = makeStyles({
  activeState: {
    backgroundColor: 'rgba(225, 229, 235, 1) !important',
  },
});

export const Container = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
});

export const PagesWrapper = styled('div')({
  margin: '0 55px',

  '& button': {
    marginRight: '6px',
    color: 'rgb(80, 86, 94)',

    '&:hover': {
      backgroundColor: 'rgb(225, 229, 235)',
    },

    '&:active': {
      backgroundColor: 'rgb(180, 187, 198)',
    },
  },
});

export const PagePlaceholder = styled('span')({
  display: 'inline-block',
  padding: '0px 18px',
  verticalAlign: 'middle',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '16px',
  letterSpacing: '0.08px',
  userSelect: 'none',
});
